import Vuex from 'vuex'
import Vue from 'vue'
import { beginDashboardUpdate, cancelControlsUpdate, finishDashboardUpdate, isCanceledRequest } from '@/http'

/* import store modules */
import auth from './modules/auth'
import summary from './modules/summary'
import daily from './modules/daily'
import board from './modules/board'
import maps from './modules/maps'
import incomes from './modules/incomes'
import controls from './modules/controls'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth /* Авторизация */,
    summary /* Summary */,
    daily /* Утренний отчет */,
    board /* Табло */,
    maps /* Карты, Статистика по направлениям */,
    incomes /* Сборы */,
    controls /* КОНТРОЛЬ И МОНИТОРИНГ */
  },
  state: {
    pageTitle: '',
    globalDataUpdateId: 0,
    snackbar: {
      text: '',
      type: 'info',
      show: false,
      timeout: 6000,
    },
    dragOptions: {
      disabled: true,
      animation: 250,
      chosenClass: 'sortable-chosen',
    },
    modules: [
      {
        id: 1,
        draggable: false,
        icon: 'trending_up',
        title: 'Статистика',
        moduleName: 'summary',
        link: '/summary',
      },
      {
        id: 2,
        draggable: false,
        icon: 'insert_chart_outlined',
        title: 'Утренний отчет',
        moduleName: 'daily',
        link: '/daily',
      },
      {
        id: 3,
        draggable: false,
        icon: 'data_usage',
        title: 'Сборы',
        moduleName: 'charges',
        link: '/incomes',
      },
      {
        id: 4,
        draggable: true,
        icon: 'flight_land',
        content: 'visArr',
        title: 'Табло прилета',
        moduleName: 'visin',
        link: '/arrival',
      },
      {
        id: 5,
        draggable: true,
        icon: 'flight_takeoff',
        content: 'visDep',
        title: 'Табло вылета',
        moduleName: 'visin',
        link: '/departure',
      },
      {
        id: 6,
        draggable: true,
        icon: 'crop_free',
        content: 'perron',
        title: 'Карта перрона',
        moduleName: 'ap',
        link: '/perron',
      },
      {
        id: 7,
        draggable: true,
        icon: 'language',
        content: 'worldmap',
        title: 'Карта мира',
        moduleName: 'wm',
        link: '/worldmap',
      },
      {
        id: 8,
        draggable: true,
        icon: 'radar',
        content: 'trackingmap',
        title: 'Карта разлёта',
        moduleName: 'tm',
        link: '/trackingmap',
      },
      {
        id: 9,
        draggable: false,
        icon: 'connecting_airports',
        content: 'control',
        title: 'Контроль и мониторинг',
        moduleName: 'summary',
        link: '/control',
      },
    ],
  },
  mutations: {
    startGlobalDataUpdate: function(state) {
      state.globalDataUpdateId++
    },
    updateSort: function(state, list) {
      state.modules = list
    },
    setPageTitle: function(state, title) {
      state.pageTitle = title
    },
    setDragOptions: function(state, dragOptions) {
      state.dragOptions = dragOptions
    },
    showMsg: function(state, options) {
      state.snackbar.timeout = options.timeout
      state.snackbar.text = options.text
      state.snackbar.type = options.type
      state.snackbar.show = true
    },
    draggablePosition: function(state, modules) {
      modules = modules || []
      let list = this.getters.getDraggableModules(false)
      state.modules = list.concat(modules)
    },
  },
  actions: {
    globalDataUpdate: async function(context, options) {
      if (!this.state.auth.user.loggedInStatus) {
        return false
      }

      context.commit('startGlobalDataUpdate')
      let updateId = context.state.globalDataUpdateId
      let requestGroup = beginDashboardUpdate()
      cancelControlsUpdate()

      try {
        // Не открываем больше двух групп соединений с SQL Server одновременно.
        // На нагруженном сервере большая пачка иногда отклоняется ещё на входе.
        const updateBatches = [
          ['summary/updateSummary', 'daily/updateDailyFlights'],
          ['daily/updateDailyPayload', 'incomes/updateIncomes'],
          ['board/updateBoards', 'maps/updateDirectionStatistic'],
          ['maps/updateSmallPerronObjects'],
        ]

        for (const batch of updateBatches) {
          await Promise.all(batch.map(action => {
            let params = action === 'incomes/updateIncomes' ? { dashboard: true } : undefined
            return context.dispatch(action, params)
          }))

          if (context.state.globalDataUpdateId !== updateId) {
            return false
          }
        }

        return context.state.globalDataUpdateId === updateId
      } finally {
        finishDashboardUpdate(requestGroup)
        if (context.state.globalDataUpdateId === updateId) {
          // Внешняя служба контроля может быть недоступна. Запрос выполняется,
          // но не удерживает обновление основных карточек.
          context.dispatch('controls/updateControls')
        }
      }
    },
    showMsg: function(context, options) {
      options.timeout = options.timeout || 6000
      options.text = options.text || ''
      options.type = options.type || 'info'
      context.commit('showMsg', options)
    },
    errorProcess: function(context, error) {
      if (isCanceledRequest(error)) {
        return
      }
      console.log(error)
      if (error.response) {
        store.dispatch('showMsg', { text: 'Ошибка!', type: 'error' })
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data)
        console.log(error.response.status)
        console.log(error.response.headers)
        if (error.response.data.error === 'Unauthorised') {
          // alert('Ошибка авторизации!')
          store.dispatch('showMsg', { text: 'Ошибка авторизации!', type: 'error' })
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
      console.log(error.config)
    },
  },
  getters: {
    getPageTitle(state) {
      return state.pageTitle
    },
    getSnackbar(state) {
      return state.snackbar
    },
    getModuleList(state) {
      return state.modules
    },
    getDragOptions(state) {
      return state.dragOptions
    },
    getFunctions(state) {
      return {
        twoDigits: function(d) {
          if (d >= 0 && d < 10) return '0' + d.toString()
          if (d > -10 && d < 0) return '-0' + (-1 * d).toString()
          return d.toString()
        },
        toSqlFormat: function(d) {
          return d.getUTCFullYear() + '-' + this.twoDigits(1 + d.getUTCMonth()) + '-' + this.twoDigits(d.getUTCDate())
        },
      }
    },
    getDraggableModules(state) {
      return function(draggable) {
        let modules = []
        state.modules.forEach(e => {
          if (
            parseInt(state.auth.user.access[e.moduleName]) === 1 &&
            parseInt(state.auth.user.access['launch']) === 1 &&
            e.moduleName != 'tm' &&
            e.draggable === draggable
          ) {
            modules.push(e)
          }
        })
        return modules
      }
    },
    getAvailableModules(state) {
      let modules = []
      state.modules.forEach(e => {
        if (parseInt(state.auth.user.access[e.moduleName]) === 1 && parseInt(state.auth.user.access['launch']) === 1) {
          modules.push(e)
        }
      })
      return modules
    },
    chechAccess(state) {
      return function(module) {
        // К табло прилета / вылета доступ определяется одним параметром - visin
        let accessModuleName = module === 'arrival' || module === 'departure' ? 'visin' : module
        return (parseInt(state.auth.user.access[accessModuleName]) && parseInt(state.auth.user.access['launch'])) || 0
      }
    },
  },
})

export default store
